
/**
 * eNvesta AI - Email Sequence Service
 * Simulates the contextual email triggers for Optimize upgrades.
 */

export interface EmailTrigger {
  subject: string;
  body: string;
  triggerCondition: string;
}

export const triggerOptimizeEmail = (userEmail: string, condition: string) => {
  let email: EmailTrigger | null = null;

  switch (condition) {
    case 'SHELF_LIFE':
      email = {
        subject: "Your feasibility study has a shelf life.",
        body: "Market dynamics change fast. Your validated venture needs live intelligence to stay viable. Add eNvesta AI Optimize to keep your data current.",
        triggerCondition: "High conviction score (75+) + 60 days since scan"
      };
      break;
    case 'WAR_ROOM_DENSITY':
      email = {
        subject: "Your War Room is reaching critical mass.",
        body: "With 3+ validated ventures, it's time to choose the one you're building. Add Optimize to turn your top pick into a live dashboard.",
        triggerCondition: "3+ saved ventures in War Room"
      };
      break;
    case 'RETURN_VISIT':
      email = {
        subject: "Still thinking about this venture?",
        body: "You've returned to this feasibility study multiple times. That's conviction. Unlock Optimize to start modeling your actual launch scenarios.",
        triggerCondition: "2+ return visits to same venture"
      };
      break;
    default:
      return;
  }

  if (email) {
    console.log(`[EMAIL TRIGGERED] To: ${userEmail}`);
    console.log(`Subject: ${email.subject}`);
    console.log(`Body: ${email.body}`);
    console.log(`Condition: ${email.triggerCondition}`);
    
    // In a real app, this would call a backend service like SendGrid or Firebase Functions
  }
};
